import styled, { CSSProperties } from "styled-components";
import { colors } from "@pepdirect/v3/styles/variables";
import { CaretIconSvg } from "@pepdirect/v3/ui/icons";

export const StyledFulfillmentItem = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius || "10px"};
  background-color: ${({ theme }) =>
    theme.page?.backgroundColor ? colors.white : colors.gray100};
  padding: 10px 20px;

  & + & {
    margin-top: 10px;
  }

  @media print {
    background-color: white;
    border: 1px solid ${colors.gray400};
    border-radius: 0;
  }
`;

export const StyledContent = styled.div<{ $visible: boolean }>`
  visibility: hidden;
  display: none;
  margin-top: 20px;
  @media print {
    display: block !important;
    visibility: visible !important;
  }

  ${({ $visible }) =>
    $visible &&
    `
    visibility: visible;
    display: block;
  `}
`;

export const StyledButton = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: -7px;
  cursor: pointer;
`;

export const StyledCaretIconSvg = styled(CaretIconSvg)`
  transition: transform 0.3s ease-in-out;
  margin-right: 2px;
  margin-top: 6px;
  @media print {
    display: none;
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StyledInfoDetail = styled.div<{
  $flexBasis: CSSProperties["flexBasis"];
}>`
  font-size: 14px;
  & + & {
    margin-left: 10px;
  }
  flex-basis: ${({ $flexBasis }) => $flexBasis};
`;

export const StyledInfoDetailTitle = styled.div`
  font-weight: bold;
`;

export const StyledStatusText = styled.div<{ $cancelled?: boolean }>`
  text-transform: capitalize;
  ${({ $cancelled }) => $cancelled && `color: ${colors.red}`}
`;
